/*
 * <product-tabs> — tabs of the product page (sections/component-product-tabs.liquid).
 * Click or arrow keys switch the visible panel; in the theme editor, selecting a
 * block shows the tab it belongs to.
 */
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));

    this.addEventListener('keydown', (event) => {
      const index = this.tabs.indexOf(event.target);
      if (index === -1) return;

      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;

      event.preventDefault();
      this.select(this.tabs[next]);
      this.tabs[next].focus();
    });

    // Theme editor: a tab block is its button; a question block lives inside a panel
    this.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[role="tabpanel"]');
      const tab = panel ? this.tabs.find((item) => item.getAttribute('aria-controls') === panel.id) : event.target;
      if (this.tabs.includes(tab)) this.select(tab);
    });
  }

  select(selected) {
    this.tabs.forEach((tab) => {
      const isSelected = tab === selected;
      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-selected', isSelected);
      tab.tabIndex = isSelected ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== selected.getAttribute('aria-controls');
    });

    // Keeps the chosen tab visible when the tab list scrolls sideways (mobile)
    const nav = selected.parentElement;
    if (nav.scrollWidth > nav.clientWidth) {
      nav.scrollTo({ left: selected.offsetLeft - nav.offsetLeft - 15, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
